/** Client-side route paths — single source of truth */
export const routes = {
  home: "/",
  styleLanding: (styleId: string) => `/style/${styleId}`,
  about: "/about",
  shop: "/shop",
  shopPoster: (slug: string) => `/shop/posters/${slug}`,
  shopPersonalize: (sessionId: string) => `/shop/personalize/${sessionId}`,
  wall: "/wall",
  generateArt: (id: string) => `/generate-art/${id}`,
  myCreations: "/my-creations",
  login: "/login",
  signUp: "/sign-up",
  createPassword: "/create-password",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password/complete",
  paymentSuccess: "/payments/success",
  terms: "/terms",
  privacy: "/privacy",
  disclaimer: "/disclaimer",
  articles: "/articles",
  article: (slug: string) => `/articles/${slug}`,
} as const;
